import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Shift } from './shift';
import { RequestOptions, Headers } from '@angular/http';
import { baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class ShiftsService {

  private url = baseUrl + gatewayFile;

  sites: Shift[];

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getShifts(site: string): Observable<Shift[]> {
    // Returns a list of positions for shifts for the selected site and date
    const url = `${this.url}`;
    return this.http.post<Shift[]>(url, { token: localStorage.getItem('token'), function: 'getShifts', item1: site })
    .pipe(
      catchError(this.handleError('getShifts', []))
    );
  }

  getValidations(site: String, date: String): Observable<Shift[]> {
    // Returns a list of positions for shifts for the selected site and date
    const url = `${this.url}`;
    return this.http.post<Shift[]>(url, { token: localStorage.getItem('token'), function: 'getValidations', item1: site, item2: date })
    .pipe(
      catchError(this.handleError('getValidations', []))
    );
  }

  deleteValidation(id: String): Observable<Shift[]> {
    // Returns a list of positions for shifts for the selected site and date
    const url = `${this.url}`;
    return this.http.post<Shift[]>(url, { token: localStorage.getItem('token'), function: 'deleteValidation', item1: id })
    .pipe(
      catchError(this.handleError('deleteValidation', []))
    );
  }

  saveValidation(site: string, currDate: string, shift: string, user: string): Observable<Shift[]> {
    // Returns a list of positions for shifts for the selected site and date
    const url = `${this.url}`;
    return this.http.post<Shift[]>(url,
      { token: localStorage.getItem('token'), function: 'saveValidation', item1: site, item2: currDate, item3: shift, item4: user }
    )
    .pipe(
      catchError(this.handleError('saveValidation', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }

}
